// extracted by mini-css-extract-plugin
export default {"root":"DnDOverlay_root__0amn0","textOverlay":"DnDOverlay_textOverlay__jN4UA"};